import { ClassValue } from 'clsx';
import { isString } from 'lodash';
import { ReactNode } from 'react';
import { Text, TextProps } from '@shared/components/Text';
import { View } from '@shared/components/View';
import styles from './ModalTitleBar.module.css';

interface TitleBarProps {
  title?: ReactNode;
  titleProps?: TextProps;
  showBorder?: boolean;
  startContent?: ReactNode;
  endContent?: ReactNode;
  className?: ClassValue;
}

export function ModalTitleBar({
  title,
  titleProps,
  showBorder = true,
  startContent,
  endContent,
  className,
}: TitleBarProps) {
  return (
    <View className={[styles.titleBar, showBorder && styles.bordered, className]}>
      <div className={styles.start}>{startContent}</div>
      <div className={styles.title}>
        {isString(title) && (
          <Text size="h4" weight="semibold" numberOfLines={1} {...titleProps}>
            {title}
          </Text>
        )}
        {!isString(title) && title}
      </div>
      <div className={styles.end}>{endContent}</div>
    </View>
  );
}
